import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (sessionId) {
      processGoogleSession(sessionId)
        .then((user) => {
          // Clear hash and navigate
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/dashboard', { state: { user }, replace: true });
        })
        .catch(() => {
          navigate('/login', { replace: true });
        });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate, processGoogleSession]);

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="w-10 h-10 border-4 border-[#E7E5E4] border-t-[#4CAF50] rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-[#57534E]">Authenticating...</p>
      </div>
    </div>
  );
}
